export var ApolloClientName = {
  ONE_CLICK: 'ONE_CLICK'
};
export var initApolloAppState = {
  uiData: {
    errorMessage: '',
    showOnlyPM: false,
    newUserNoMop: true,
    cardActionMode: 'None',
    isLoaded: false,
    isCTALoading: false,
    isCTADisabled: false,
    showInitializeError: false
  },
  orderData: {
    token: '',
    cartId: '',
    yiftee: false
  },
  reviewData: {
    currentStep: 1
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/one-click/dist/esm/lib/ApolloSchema/constants.js
// module id = 4172
// module chunks = 11